import { render, staticRenderFns } from "./modalContactInfo.vue?vue&type=template&id=4306dd6c&scoped=true&"
import script from "./modalContactInfo.vue?vue&type=script&lang=js&"
export * from "./modalContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./modalContactInfo.vue?vue&type=style&index=0&id=4306dd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4306dd6c",
  null
  
)

export default component.exports